// https://reactjs.org/docs/concurrent-mode-suspense.html#using-suspense-in-practice
import React from "react";

import Bowser from "bowser";

export interface IErrorBoundaryProps {
  children?: React.ReactNode;
  fallback?: any;
}

// Error boundaries currently have to be classes.
export default class ErrorBoundary extends React.Component<IErrorBoundaryProps> {
  _isChrome?: boolean;
  state = {hasError: false, error: null};

  static getDerivedStateFromError(error: any) {
    return {
      hasError: true,
      error,
    };
  }

  get isChrome(): boolean {
    if (this._isChrome === undefined) {
      const parser = Bowser.getParser(window.navigator.userAgent);
      this._isChrome = parser.isBrowser("Chrome");
    }
    return this._isChrome;
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      else
        return (
          <div
            style={{flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}
          >
            <h2>Something went wrong...</h2>
            {!this.isChrome && (
              <>
                <h3>Cantāmus is optimized to have maximum compatibility with the Chrome browser.</h3>
                <h3>Please try using the Chrome browser.</h3>
              </>
            )}
          </div>
        );
    }
    return this.props.children;
  }
}
